import React, { useState, useEffect } from 'react';
import './GrowthPartnerPage.css';
import Header from './Header';
import AnimatedBackground from './AnimatedBackground';

const GrowthPartnerPage = () => {
  const [growthFormSent, setGrowthFormSent] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleGrowthFormSubmit = (e) => {
    e.preventDefault();
    setGrowthFormSent(true);
  };

  const ecosystems = [
    {
      name: 'RGS Marketing Experience',
      url: 'https://rgsbtl.com/',
      description: 'Agencia de marketing digital y BTL en Colombia. +25 años creando experiencias que marcan.',
      tags: ['Marketing BTL', 'Activaciones', 'Eventos corporativos']
    },
    {
      name: 'Strutech Solutions',
      url: 'https://strutechsolutions.com/',
      description: 'Diseño y construcción en Bogotá. Arquitectura, interiorismo y soluciones que transforman espacios.',
      tags: ['Arquitectura', 'Interiorismo', 'Remodelaciones']
    }
  ];

  return (
    <div className="growth-partner-page">
      <Header />
      <AnimatedBackground particleCount={15} staticCount={4} />

      <main className="gp-main">
        <div className="gp-hero">
          <div className="gp-content-wrap">
            <div className="gp-shapes" aria-hidden="true">
              <div className="gp-shape gp-shape-1"></div>
              <div className="gp-shape gp-shape-2"></div>
              <div className="gp-shape gp-shape-3"></div>
              <div className="gp-shape gp-shape-4"></div>
            </div>
            <div className="gp-content">
            <span className="gp-tag">GROWTH PARTNER</span>
            <h1 className="gp-headline">Sistemas digitales hechos por amigos</h1>
            <p className="gp-narrative">
              Somos un grupo de amigos profesionales que unieron fuerzas para montar sistemas digitales.
              Con el tiempo los volvemos más robustos y ganamos siendo comercial del mismo producto.
            </p>
            <div className="gp-pillars">
              <span className="gp-pillar"><i className="fas fa-users"></i> Equipo</span>
              <span className="gp-pillar"><i className="fas fa-code"></i> Sistemas</span>
              <span className="gp-pillar"><i className="fas fa-chart-line"></i> Crecimiento</span>
            </div>
          </div>
          </div>

          <div className="gp-form-section">
            <h2 className="gp-form-title">¿Quieres conectar?</h2>
            {growthFormSent ? (
              <div className="gp-form-success">
                <i className="fas fa-check-circle"></i>
                <p>Gracias por tu mensaje. Te responderemos pronto.</p>
              </div>
            ) : (
              <form className="gp-form" onSubmit={handleGrowthFormSubmit}>
                <input type="text" placeholder="Nombre" required />
                <input type="email" placeholder="Email" required />
                <textarea placeholder="Cuéntanos tu proyecto o idea" rows="4"></textarea>
                <button type="submit" className="gp-form-btn">Enviar</button>
              </form>
            )}
          </div>
        </div>

        {/* Sección: ¿Te gustó esta página? */}
        <section className="gp-ecosystems-section">
          <div className="gp-ecosystems-wrap">
            <h2 className="gp-ecosystems-headline">¿Te gustó esta página?</h2>
            <p className="gp-ecosystems-subline">
              Podríamos ayudarte con tu ecosistema digital. Sitios web, tiendas online, sistemas a medida.
            </p>
            <div className="gp-ecosystems-grid">
              {ecosystems.map((eco, i) => (
                <a
                  key={i}
                  href={eco.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gp-ecosystem-card"
                >
                  <div className="gp-ecosystem-icon">
                    <i className="fas fa-globe"></i>
                  </div>
                  <h3 className="gp-ecosystem-name">{eco.name}</h3>
                  <p className="gp-ecosystem-desc">{eco.description}</p>
                  <div className="gp-ecosystem-tags">
                    {eco.tags.map((tag, j) => (
                      <span key={j} className="gp-ecosystem-tag">{tag}</span>
                    ))}
                  </div>
                  <span className="gp-ecosystem-link">
                    Visitar <i className="fas fa-external-link-alt"></i>
                  </span>
                </a>
              ))}
            </div>
          </div>
        </section>
      </main>

    </div>
  );
};

export default GrowthPartnerPage;
